import { IconButton, IconButtonProps, Tooltip, useTheme } from '@mui/material';

export const CommonSendTestIconButton = (props: IconButtonProps) => {
  const theme = useTheme();
  return (
    <Tooltip title="Send test email">
      <IconButton size="small" {...props}>
        <i
          className="fa-light fa-paper-plane"
          style={{ color: theme.palette.primary.main }}
        />
      </IconButton>
    </Tooltip>
  );
};
